import React from 'react'
import { Container, StyledIconButton, Link } from './Navigation.styles'

import {
  CLIENT_MANAGEMENT_CLIENTS,
  CLIENT_MANAGEMENT_CONTRACTS,
  CLIENT_MANAGEMENT_PROCESS,
  CLIENT_MANAGEMENT_CONTENT,
  CLIENT_MANAGEMENT_ACTIVITIES,
  CLIENT_MANAGEMENT_USERS
} from 'routes/paths'

const Navigation = () => {
  return (
    <Container role="navigation">
      <Link to={CLIENT_MANAGEMENT_CLIENTS}>
        <StyledIconButton
          tiny
          secondaryBlack
          iconLeft
          iconColor="inherit"
          iconName="bag-money"
        >
          Clientes
        </StyledIconButton>
      </Link>
      <Link to={CLIENT_MANAGEMENT_USERS}>
        <StyledIconButton
          tiny
          secondaryBlack
          iconLeft
          iconColor="inherit"
          iconName="user-heart"
        >
          Usuários
        </StyledIconButton>
      </Link>
      <Link to={CLIENT_MANAGEMENT_CONTRACTS}>
        <StyledIconButton
          tiny
          secondaryBlack
          iconLeft
          iconColor="inherit"
          iconName="content"
        >
          Contratos
        </StyledIconButton>
      </Link>
      <Link to={CLIENT_MANAGEMENT_PROCESS}>
        <StyledIconButton
          tiny
          secondaryBlack
          iconLeft
          iconColor="inherit"
          iconName="timer"
        >
          Processos
        </StyledIconButton>
      </Link>
      <Link to={CLIENT_MANAGEMENT_CONTENT}>
        <StyledIconButton
          tiny
          secondaryBlack
          iconLeft
          iconColor="inherit"
          iconName="notebook"
        >
          Conteúdo
        </StyledIconButton>
      </Link>
      <Link to={CLIENT_MANAGEMENT_ACTIVITIES}>
        <StyledIconButton
          tiny
          secondaryBlack
          iconLeft
          iconColor="inherit"
          iconName="notebook"
        >
          Atividades
        </StyledIconButton>
      </Link>
    </Container>
  )
}

export default Navigation
